/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { Col, Row, message } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import { Button, Text } from 'shared/components';
import CREATE_CUSTOMER_MUTATION, {
  CreateCustomerData,
  CreateCustomerVars,
} from 'shared/graphql/mutation/createCustomer';
import { useFormContext } from 'react-hook-form';
import {
  CustomerBankMode,
  FormValues,
} from 'views/Setting/Routes/Customer/Routes/CustomerDetail/formValues.model';
import { StyledModal } from './Styles';

type ModalConfirmCreateProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmCreate: React.FC<ModalConfirmCreateProps> = (props) => {
  const { onCancel, visible } = props;

  const history = useHistory();

  const { handleSubmit, watch } = useFormContext<FormValues>();

  const [createCustomer, { loading }] = useMutation<CreateCustomerData, CreateCustomerVars>(
    CREATE_CUSTOMER_MUTATION,
    {
      update: (_cache, { data }) => {
        if (data?.createCustomer._id) {
          onCancel();
          message.success('สร้างบัญชีลูกหนี้แล้ว');
          history.push('/setting/customer');
        }
      },
      onError: (err) => {
        message.error(err.message);
      },
    },
  );

  const submit = handleSubmit((values) => {
    createCustomer({
      variables: {
        from: values.from,
        first_name: values.firstName,
        last_name: values.lastName,
        full_name: `${values.firstName} ${values.lastName}`,
        email: values.email.map((item) => item.text),
        phone: [values.phone],
        tax_id: values.taxId,
        branch: values.branch,
        address: values.address,
        sub_district: values.subDistrict,
        district: values.district,
        province: values.province,
        postcode: values.postCode,
        business_invoice_type: values.businessInvoiceType,
        business_invoice_date_range: {
          start: values.businessInvoiceDateRangeStart,
          end: values.businessInvoiceDateRangeEnd,
        },
        payment_bank_account: {
          bank_name: values.bankName,
          bank_branch: values.bankBranch,
          account_name: values.accountName,
          account_number: values.accountNumber,
        },
        business_pay_round: {
          round_date: values.businessPayRoundRoundDate ? values.businessPayRoundRoundDate : '0',
          after_invoice: values.businessPayRoundRoundAfterInvoice
            ? values.businessPayRoundRoundAfterInvoice
            : '0',
        },
        customer_bank_account: {
          mode:
            values.customerBankMode === CustomerBankMode.PROMPT_PAY
              ? 3
              : values.customerBankMode === CustomerBankMode.BANK_ACCOUNT &&
                values.customerBankCode === '002'
              ? 1
              : 2,
          bank_id:
            values.customerBankMode === CustomerBankMode.BANK_ACCOUNT
              ? values.customerBankId
              : undefined,
          account_name: values.customerAccountName,
          account_number: values.customerAccountNumber,
          promptPay:
            values.customerBankMode === CustomerBankMode.PROMPT_PAY
              ? {
                  type: values.customerBankPromptPayMode,
                  account_number: values.customerAccountNumber,
                }
              : undefined,
        },
      },
    });
  });

  return (
    <StyledModal
      className="custom-modal"
      title="ยืนยันการเพิ่มบัญชีลูกหนี้ ใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CheckCircleOutlined />}
          color="green"
          onClick={() => submit()}
          loading={loading}
        >
          ใช่, เพิ่มบัญชีลูกหนี้
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>ชื่อ:</Col>
        <Col span={18}>
          <Text strong>{watch('firstName') || '-'}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>นามสกุล:</Col>
        <Col span={18}>
          <Text strong>{watch('lastName') || '-'}</Text>
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmCreate;
